import { render } from "./Berita.vue?vue&type=template&id=80cd92f0&scoped=true"
import script from "./Berita.vue?vue&type=script&lang=js"
export * from "./Berita.vue?vue&type=script&lang=js"

import "./Berita.vue?vue&type=style&index=0&id=80cd92f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80cd92f0"]])

export default __exports__